export default function renderAdrTaSignatureV3(data) {
  return function (pdf) {};
}
